import React from 'react'
import { IconButton, MoreIcon, Pagination, Spinner } from 'evergreen-ui'
import { GuestListTableContainer } from '../../owner/owner.style'
import { TableBodyRow, TableHead } from '../../../../../widget/styledComponents/table.style'
import { gql, useQuery } from '@apollo/client';



export const FETCH_PROPERTY_TRANSACTIONS = gql`
query Transactions_getByProperty($propertyId: ID!) {
  transactions_getByProperty(propertyId: $propertyId) {
    _id
    amount
    paymentReference
    narration
    cardDetails {
      expMonth
      maskedPan
      expYear
    }
    bankDetails {
      accountName
      accountNumber
      bankCode
    }
    transactionTime
    id
  }
}
`;


function Transactions(props) {
  const property = props.details
  console.log("d--",property._id)
  const { loading,error,data }   = useQuery(FETCH_PROPERTY_TRANSACTIONS,{
      variables: {
          propertyId:property._id
       },
  });
  
if (loading) return <Spinner/>;
if (error) return <div>
  <i className='material_icons'>error_outline</i>
</div>;
const transactions = data.transactions_getByProperty
return (
  <div>

      <GuestListTableContainer>
          <table className='responsive-table'>
              <thead>
              <tr
              >
                  <TableHead>Title</TableHead>
                  <TableHead>Amount</TableHead>
                  <TableHead>Date of payment</TableHead>
                  <TableHead>
                    Status
                  </TableHead>
                  <TableHead>
                    <MoreIcon />
                  </TableHead>

              </tr>
              </thead>

              <tbody>
                  {/* {loading && <Spinner/> } */}
                  {
                    transactions.map((data)=>
                      <TableBodyRow
                      >
                          <td>
                            {data.narration}
                          </td>
                          <td>N{data.amount}</td>
                          <td>{data.transactionTime}</td>
                          <td>
                          Successful
                          </td>
                          <td>
                            <IconButton
                            icon={MoreIcon} intent="primary"  />
                            
                          </td>
                        
                      </TableBodyRow>
                    )
                  }
              </tbody>
          </table>
          <Pagination className='transparent z-depth-0' totalPages={4} 
            // onPageChange={(e)=>pageChange(e)}
            // onNextPage={(e)=>nextPage()}
            // onPreviousPage={(e)=>prevPage()}
          ></Pagination>             
      </GuestListTableContainer>
  </div>


  )
}

export default Transactions